import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {ValidationStateModel} from '../../modules/validation/models/validation-state.model';
import {Calculation} from '../../models/api/calculation.model';
import {CalculationPolicyEditActions} from './calculation-policy-edit.actions';
import {catchError, tap} from 'rxjs/operators';
import {NotificationService} from '../../services/notification.service';
import {NavService} from '../../services/nav.service';
import {instanceToPlain} from 'class-transformer';
import {PolicyService} from '../../services/policy.service';
import {HttpErrorResponse} from '@angular/common/http';
import {of} from 'rxjs';
import {ValidationActions} from '../../modules/validation/state/validation.actions';
import {Policy} from '../../models/api/product/base.model';
import {skipInterceptors} from '../../helpers/request.helper';
import {PolicyHelper} from '../../helpers/policy.helper';

interface CalculationPolicyEditStateModel extends ValidationStateModel {
    activeCalculation?: Calculation;
}

@State<CalculationPolicyEditStateModel>({
    name: CalculationPolicyEditState.STATE_NAME,
    defaults: {
        activeCalculation: null,
        validationErrors: null,
    },
})
@Injectable()
export class CalculationPolicyEditState {
    static readonly STATE_NAME = 'calculationPolicy';

    constructor(
        protected policyService: PolicyService,
        protected notificationService: NotificationService,
        protected navService: NavService,
        protected policyHelper: PolicyHelper
    ) {}

    @Selector()
    static activeCalculation(state: CalculationPolicyEditStateModel) {
        return state.activeCalculation;
    }

    @Action(CalculationPolicyEditActions.SetCalculationData)
    setCalculationData(
        ctx: StateContext<CalculationPolicyEditStateModel>,
        {originalCalculation}: CalculationPolicyEditActions.SetCalculationData
    ) {
        ctx.patchState({
            activeCalculation: originalCalculation,
        });
    }

    @Action(CalculationPolicyEditActions.Save)
    save(
        ctx: StateContext<CalculationPolicyEditStateModel>,
        {request, productCode}: CalculationPolicyEditActions.Save
    ) {
        const body = instanceToPlain(request);
        return this.policyService.savePolicy(body, productCode, skipInterceptors([409, 422])).pipe(
            tap((res: Policy[]) => {
                this.policyHelper.handleSavePolicyResponse(res, ctx, request.calculationId);
            }),
            catchError((reject: HttpErrorResponse) => {
                if (reject.status === 409) {
                    this.notificationService.error(reject?.error?.message || reject?.error);
                } else {
                    ctx.dispatch(new ValidationActions.Set(CalculationPolicyEditState.STATE_NAME, reject?.error));
                }
                return of(null);
            })
        );
    }
}
